import React, { useRef, useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import Footer from '../components/Footer'
import Header from '../components/Header'
import PaymentVoucher from '../components/PaymentVoucher'
import { useSelector } from 'react-redux'
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import { PDFDownloadLink } from '@react-pdf/renderer'
import { PVPdfTemplate } from '../components/vouchers/PaymentVoucherPdf';
import { mobile } from '../responsive';

const ButtonContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
`
const PFVersion = styled.div`
    font-size: 14px;
    border: none;
    padding: 5px;
    background: teal;
    color: white;
    cursor: pointer;
    margin: 20px;
    border-radius: 10px;

    &:hover{
        background: white;
        color: teal;
    }

    ${mobile({
        margin: '5px'
    })}
`

const StyledLink = styled(Link)`
    text-decoration: none;
    color: inherit;
    
`

const PVView = () => {
    const {voucherId} = useParams();
    const pv = useSelector(state => state.pv);
    const [voucher, setVoucher] = useState({});
    const pageRef = useRef();
    const buttonRef = useRef();

    useEffect(() => {
        const fetchData = async () => {
            try{
                //load current voucher
                const filterList = await pv?.vouchers?.filter((item) => (item.voucherNo === voucherId));
                const filterVoucher = (filterList[0]);
                //load count of vouchers in same project
                const count = (pv?.vouchers?.reduce((count, item) => {
                    if( item.project === filterVoucher.project )
                        count += 1;
                    return count;
                }, 0));

                setVoucher({...filterVoucher, 'projectCount' : count});
            }
            catch(error){
                console.log(error);
            }
        };

        return fetchData();

    }, [pv, voucherId]);

    const handlePrint = useReactToPrint({
        content: () => pageRef.current,
    });

    const handleWindowPrint = () => {
        buttonRef.current.style.display = 'none';
        //window.print();
        handlePrint();
        buttonRef.current.style.display = '';
    }



    return (
        <div ref={pageRef}>
        
            <Header/>
            {voucher && Object.entries(voucher).length > 0 && 
            <>
            
                <PaymentVoucher voucher = {voucher} />
                <ButtonContainer ref={buttonRef}>
                <StyledLink to={`/vouchers/pfv/${voucher?.voucherNo}`} target='_blank'>
                        <PFVersion>
                            Printer Friendly Version
                        </PFVersion>
                </StyledLink>
                <PFVersion onClick={handleWindowPrint}>
                    Print This Page
                </PFVersion>
                
                <PFVersion>
                    <PDFDownloadLink
                        document={<PVPdfTemplate voucher={voucher}/>}
                        fileName='MegaPV26012022.pdf'
                        style={{textDecoration: 'none', color: 'inherit'}}>
                        
                        {({blob, url, loading, error}) => (loading ? 'Loading document...' : 'Download PV')} 
                        
                    </PDFDownloadLink>
                </PFVersion>
             </ButtonContainer>
            </>
            }
            
            
            <Footer/>
        </div>
    )
}

export default PVView
